import { defineStyle } from '@chakra-ui/react';

const underlineLink = defineStyle(() => ({
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    _hover: {
        textDecoration: 'underline',
    },
}));

export const textTheme = {
    variants: {
        'underline-link': underlineLink,
    },
};
